import React, { useEffect, useState } from "react";
import {
  Container,
  FormGroup,
  FormLabel,
  InputGroup,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import countries from "../helpers/countries.json";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { validateEmail } from "../helpers/functions";
import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";
import { isValidPhoneNumber } from "libphonenumber-js";

const commsOptions = [
  { value: "sms", label: "Sms" },
  { value: "email", label: "Email" },
  { value: "voice", label: "Voice" },
  { value: "threaded", label: "Threaded" },
  //   { value: "inbound", label: "Inbound" },
];

const countriesOptions = countries.map((c) => ({
  value: c.mcc_id.toString(),
  label: c.country,
}));

const statusesOptions = [
  { value: "A", label: "Accepted" },
  { value: "B", label: "Busy" },
  { value: "C", label: "Cancelled" },
  { value: "D", label: "Delivered" },
  { value: "E", label: "Expired" },
  { value: "F", label: "Failed" },
  { value: "H", label: "Hung up" },
  { value: "I", label: "Ignored" },
  { value: "L", label: "Rate Limited" },
  { value: "O", label: "Opened" },
  { value: "P", label: "Pending" },
  { value: "R", label: "Retrying" },
  { value: "Q", label: "Queued" },
  { value: "S", label: "Sent" },
  { value: "U", label: "Undeliverable" },
  { value: "X", label: "Payment required" },
];
const newRule = {
  IsActive: true,
  Status: "inactive",
  DbRef: "", // single select, 1 value, optional empty = display msg "applies to all dbs", if empty, do not offer option data:account and data:customer
  Description: "",
  Message: "",
  RunEvery: "1m", // 1m/2h/3d (minutes/hours/days) available only if Action==compare,exists,missing //otherwise must be 1m
  Period: "1m", // required, 1m/2h/3d (minutes/hours/days) available only if Action==compare,exists,missing, label: "Compare last"
  Level: "info", // single select, 1 value required: info/warning/danger
  Action: "missing", // single select, 1 value required: missing/new/exists/compare
  CompareChangeDirection: "both", // single select, 1 value required: both/increase/decrease //avaible only if Action==compare
  CompareChange: 0, // integer input, min=1, required, available only if Action==compare
  MinValue: 0, // integer input, min=0, required, available only if Action==compare,exists,new
  MaxValue: 0, // integer input, min=0, required, available only if Action==compare,exists,new
  CompareUnit: "abs", // single select, 1 value required: abs/precent, available only if Action==compare
  ComparePeriod: "0m", // required, 1m/2h/3d, available only if Action==compare, label: "Compare with"
  ComparePeriodOffset: "0m", // optional, 1m/2h/3d, available only if Action==compare, label: "Offset compared data"
  CompareGroup: "m", // (m)minutes/(h)ours/(d)ays) , available only if Action==compare, label: "Group data"
  CompareBestCount: 0, // integer, at least 1, available only if Action==compare, label: "Compare X best groups"
  RunAfter: "00:00",
  RunBefore: "24:00", // must be after RunAfter
  RunOnMonday: true, // at least one day fo the week must be enabled
  RunOnTuesday: true, // at least one day fo the week must be enabled
  RunOnWednesday: true, // at least one day fo the week must be enabled
  RunOnThursday: true, // at least one day fo the week must be enabled
  RunOnFriday: true, // at least one day fo the week must be enabled
  RunOnSaturday: true, // at least one day fo the week must be enabled
  RunOnSunday: true, // at least one day fo the week must be enabled
  IsGlobal: false,
  IsSystem: false,
  NoComms: false,
  Statuses: ["D"],
  SendToSlack: false,
  Options: [
    // // 4 multiselects same as in filters, each selected value sent as option
    // {
    //   Key: "data:kind",
    //   Value: "sms", // sms/threaded/email/voice
    // },
    // {
    //   Key: "data:country",
    //   Value: "234", // country mcc, string!!!!!!!!
    // },
    // // if dbRef is empty, cannot offer
    // {
    //   Key: "data:account",
    //   Value: "1", // account id, string!!!!!!!!
    // },
    // {
    //   Key: "data:customer",
    //   Value: "1", // customer id, string!!!!!!!!
    // },
    // {
    //   Key: "data:parent",
    //   Value: "1", // customer id, string!!!!!!!!
    // },
  ],
};

export default function RuleForm() {
  const user = useSelector(selectUser);
  const { ruleID } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [dbRefOptions, setDbRefOptions] = useState();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);

  const [emailError, setEmailError] = useState(false);
  const [smsError, setSmsError] = useState(false);

  const [rule, setRule] = useState(null);
const [showErrors, setShowErrors] = useState(false);
  const getDbInfo = async () => {
    let headersList = {
      Accept: "*/*",
    };

    let response = await fetch("/auth/db-info", {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();

    if (response.ok) {
      setDbRefOptions([
        { value: "", label: "All dbs" },
        ...data.map((db) => ({
          value: db.DbRef,
          label: db.DbRef + " - " + db.Description,
          db,
        })),
      ]);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  const submitRule = async (e) => {
    e.preventDefault();
    setShowErrors(true)
    if (!rule.Description) {
      toast.error("Description is required.");
      return;
    }
    if (!rule.Message) {
      toast.error("Message is required.");
      return;
    }
    if (
      ["compare", "missing", "exists", "status-breakdown", "new"].includes(
        rule.Action
      ) &&
      !(rule.RunEvery.slice(0, -1) > 0)
    ) {
      toast.error("Minimum required value for run every is 1.");
      return;
    }
    if (
      ["compare", "missing", "exists", "status-breakdown", "new"].includes(
        rule.Action
      ) &&
      !(rule.Period.slice(0, -1) > 0)
    ) {
      toast.error("Minimum required value for compare last is 1.");
      return;
    }
    
    if (
      ["compare", "new", "exists", "status-breakdown"].includes(
        rule.Action
      ) &&
      rule.MinValue !== 0 && rule.MaxValue !==0 && rule.MinValue >= rule.MaxValue
    ) {
      toast.error("Min number of transactions must be smaller than max number of transactions.");
      return;
    }
    if (
      ["compare"].includes(
        rule.Action
      ) &&
      !(rule.ComparePeriod.slice(0, -1) > 0)
    ) {
      toast.error("Minimum required value for compare with is 1.");
      return;
    }
    if (
      ["compare"].includes(
        rule.Action
      ) &&
      !(rule.CompareBestCount > 0)
    ) {
      toast.error("Minimum required value for compare X best groups is 1.");
      return;
    }
    if (
      ["compare"].includes(
        rule.Action
      ) &&
      !(rule.CompareChange > 0)
    ) {
      toast.error("Minimum required value for compare change is 1.");
      return;
    }
    if (
      ["status-breakdown"].includes(
        rule.Action
      ) &&
      !(rule.CompareChange > 0)
    ) {
      toast.error("Minimum required value for compare change is 1.");
      return;
    }
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify(rule);

    let response = await fetch(
      `/auth/rules/${ruleID === "new" ? "" : ruleID}`,
      {
        method: ruleID === "new" ? "POST" : "PATCH",
        body: bodyContent,
        headers: headersList,
      }
    );

    let data = await response.json();
    if (response.ok) {
      toast.success(data.message);
      navigate("/rules");
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  const getRule = async () => {
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let response = await fetch(`/auth/rules/${ruleID}`, {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      setRule(data);
      const dbOpt = dbRefOptions.find((opt) => opt.db?.DbRef === data.DbRef);
      setAccountOptions(
        dbOpt?.db?.Accounts?.map((a) => ({
          value: a.Id,
          label: a.Label,
        })) ?? []
      );
      setCustomerOptions(
        dbOpt?.db?.Customers?.map((a) => ({
          value: a.Id,
          label: a.Label,
          customer: a,
        })) ?? []
      );
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  useEffect(() => {
    (async () => {
      if (!dbRefOptions) {
        await getDbInfo();
      }
      if (dbRefOptions) {
        if (ruleID === "new") {
          setRule(newRule);
        } else if (ruleID) {
          getRule();
        }
      }
    })();
  }, [ruleID, dbRefOptions]);

  return (
    rule && (
      <Container fluid>
        <h3 className="my-3">Add Rule</h3>
        <Form onSubmit={submitRule} style={{ marginBottom: 50 }}>
          <Tabs
            defaultActiveKey="1"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="1" title="Rule">
              <div className="row mb-3">
                {
                  // single select, 1 value required: info/warning/danger
                  <div className="col-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      aria-label="Status"
                      value={rule.Status}
                      onChange={(e) =>
                        setRule({
                          ...rule,
                          Status: e.target.value,
                        })
                      }
                      disabled={false}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="archived">Archieved</option>
                    </Form.Select>
                  </div>
                }

                {
                  // single select, 1 value, optional empty = display msg "applies to all dbs", if empty, do not offer option data:account and data:customer
                  <div className="col-3">
                    <Form.Label>Select database</Form.Label>
                    <Select
                      value={dbRefOptions.find((db) => db.value === rule.DbRef)}
                      onChange={(v) => {
                        setRule({ ...rule, DbRef: v?.value ?? "" });
                        if (v) {
                          setAccountOptions(
                            v.db?.Accounts?.map((a) => ({
                              value: a.Id,
                              label: a.Label,
                            })) ?? []
                          );
                          setCustomerOptions(
                            v.db?.Customers?.map((a) => ({
                              value: a.Id,
                              label: a.Label,
                              customer: a,
                            })) ?? []
                          );
                        }
                      }}
                      options={dbRefOptions}
                      isClearable
                    />
                  </div>
                }
                {
                  // single select, 1 value required: info/warning/danger
                  <div className="col-3">
                    <Form.Label>Level</Form.Label>
                    <Form.Select
                      aria-label="level"
                      value={rule.Level}
                      onChange={(e) =>
                        setRule({
                          ...rule,
                          Level: e.target.value,
                        })
                      }
                    >
                      <option value="info">Info</option>
                      <option value="warning">Warning</option>
                      <option value="danger">Danger</option>
                    </Form.Select>
                  </div>
                }
                {
                  // single select, 1 value required: missing/new/exists/compare
                  <div className="col-3">
                    <Form.Label>Action</Form.Label>
                    <Form.Select
                      aria-label="action"
                      value={rule.Action}
                      onChange={(e) =>
                        setRule((prev) => {
                          if (e.target.value === "compare") {
                            return {
                              ...prev,
                              Action: e.target.value,
                              CompareChangeDirection: "both",
                            };
                          }
                          if (e.target.value === "status-breakdown") {
                            return {
                              ...prev,
                              Action: e.target.value,
                              CompareChangeDirection: "more",
                            };
                          }
                          if (
                            ["new", "missing"].includes(e.target.value) &&
                            prev.IsGlobal &&
                            prev.IsSystem &&
                            prev.NoComms
                          ) {
                            return {
                              ...prev,
                              Action: e.target.value,
                              NoComms: false,
                            };
                          }
                          return {
                            ...prev,
                            Action: e.target.value,
                          };
                        })
                      }
                    >
                      <option value="missing">
                        Data missing in selected period
                      </option>
                      <option value="new">New data found</option>
                      <option value="exists">
                        Data exists in selected period
                      </option>
                      <option value="compare">Compare two periods</option>
                      <option value="status-breakdown">
                        Statuses breakdown
                      </option>
                    </Form.Select>
                  </div>
                }
              </div>
              <div className="mb-3">
                <Form.Label>Action help - content pending</Form.Label>
                <div></div>
              </div>
              <div className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  value={rule.Description}
                  onChange={(e) =>
                    setRule({ ...rule, Description: e.target.value })
                  }
                />
              </div>
              {!rule.Description && showErrors && (
                <div className="alert alert-danger mb-3 p-1">
                  Description is required.
                </div>
              )}
              <div className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  value={rule.Message}
                  onChange={(e) =>
                    setRule({ ...rule, Message: e.target.value })
                  }
                />
              </div>
              {!rule.Message && showErrors && (
                <div className="alert alert-danger mb-3 p-1">
                  Message is required.
                </div>
              )}
              <Row>
                {
                  // 1m/2h/3d (minutes/hours/days) available only if Action==compare,exists,missing //otherwise must be 1m
                  [
                    "compare",
                    "missing",
                    "exists",
                    "status-breakdown",
                    "new",
                  ].includes(rule.Action) && (
                    <div className="mb-3 col-12 col-md-6">
                      <Form.Label>Run Every</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="time period"
                          aria-label="time period"
                          aria-describedby="basic-addon2"
                          min={0}
                          value={rule.RunEvery.slice(0, -1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              RunEvery:
                                e.target.valueAsNumber +
                                "" +
                                rule.RunEvery.slice(-1),
                            })
                          }
                        />
                        <Form.Select
                          aria-label="run every unit"
                          value={rule.RunEvery.slice(-1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              RunEvery:
                                rule.RunEvery.slice(0, -1) +
                                "" +
                                e.target.value,
                            })
                          }
                        >
                          <option value="m">minutes</option>
                          <option value="h">hours</option>
                          <option value="d">days</option>
                        </Form.Select>
                      </InputGroup>
                      {!(rule.RunEvery.slice(0, -1) > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                    </div>
                  )
                }
                {
                  // Period
                  // required, 1m/2h/3d (minutes/hours/days)
                  // available only if Action==compare,exists,missing, label: "Compare last"
                  [
                    "compare",
                    "missing",
                    "exists",
                    "status-breakdown",
                    "new",
                  ].includes(rule.Action) && (
                    <div className="mb-3 col-12 col-md-6">
                      <Form.Label>Compare last</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="compare last time period"
                          aria-label="compare last time period"
                          min={0}
                          value={rule.Period.slice(0, -1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              Period:
                                e.target.valueAsNumber +
                                "" +
                                rule.Period.slice(-1),
                            })
                          }
                        />
                        <Form.Select
                          aria-label="compare last unit"
                          value={rule.Period.slice(-1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              Period:
                                rule.Period.slice(0, -1) + "" + e.target.value,
                            })
                          }
                        >
                          <option value="m">minutes</option>
                          <option value="h">hours</option>
                          <option value="d">days</option>
                        </Form.Select>
                      </InputGroup>

                      {!(rule.Period.slice(0, -1) > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                    </div>
                  )
                }
              </Row>

              {
                // single select, 1 value required: both/increase/decrease
                // avaible only if Action==compare
                rule.Action === "compare" && (
                  <Row>
                    <div className="mb-2 col-12 col-md-6">
                      <Form.Label>Offset Compare Data </Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="offset compare data"
                          aria-label="offset compare data "
                          aria-describedby="basic-addon2"
                          min={0}
                          value={rule.ComparePeriodOffset.slice(0, -1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              ComparePeriodOffset:
                                e.target.valueAsNumber +
                                "" +
                                rule.ComparePeriodOffset.slice(-1),
                            })
                          }
                        />
                        <Form.Select
                          aria-label="offset compare data"
                          value={rule.ComparePeriodOffset.slice(-1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              ComparePeriodOffset:
                                rule.ComparePeriodOffset.slice(0, -1) +
                                "" +
                                e.target.value,
                            })
                          }
                        >
                          <option value="m">minutes</option>
                          <option value="h">hours</option>
                          <option value="d">days</option>
                        </Form.Select>
                      </InputGroup>
                    </div>
                    <div className="mb-2 col-12 col-md-6">
                      <Form.Label>Compare with</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="compare period"
                          aria-label="compare period"
                          aria-describedby="basic-addon2"
                          min={0}
                          value={rule.ComparePeriod.slice(0, -1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              ComparePeriod:
                                e.target.valueAsNumber +
                                "" +
                                rule.ComparePeriod.slice(-1),
                            })
                          }
                        />
                        <Form.Select
                          aria-label="compare period"
                          value={rule.ComparePeriod.slice(-1)}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              ComparePeriod:
                                rule.ComparePeriod.slice(0, -1) +
                                "" +
                                e.target.value,
                            })
                          }
                        >
                          <option value="m">minutes</option>
                          <option value="h">hours</option>
                          <option value="d">days</option>
                        </Form.Select>
                      </InputGroup>
                      {!(rule.ComparePeriod.slice(0, -1) > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                    </div>
                    <div className="mb-2 col-12 col-md-6">
                      <Form.Label>Compare Change Direction</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Select
                          aria-label="compare change direction"
                          value={rule.CompareChangeDirection}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              CompareChangeDirection: e.target.value,
                            })
                          }
                        >
                          <option value="both">Both</option>
                          <option value="increase">Increase</option>
                          <option value="decrease">Decrease</option>
                        </Form.Select>
                      </InputGroup>
                    </div>

                    <div className="mb-2 col-12 col-md-6">
                      <Form.Label>Compare Change</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Compare change"
                          aria-label="compare change"
                          aria-describedby="basic-addon2"
                          min={1}
                          value={rule.CompareChange}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              CompareChange: e.target.valueAsNumber,
                            })
                          }
                        />
                        <Form.Select
                          aria-label="compare unit"
                          value={rule.CompareUnit}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              CompareUnit: e.target.value,
                            })
                          }
                        >
                          <option value="abs">absolute value</option>
                          <option value="precent">percent</option>
                        </Form.Select>
                      </InputGroup>
                      {!(rule.CompareChange > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                    </div>

                    <div className="mb-2 col-12 col-md-6 ">
                      <Form.Label>Group Data </Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Select
                          aria-label="group data"
                          value={rule.CompareGroup}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              CompareGroup: e.target.value,
                            })
                          }
                        >
                          <option value="m">minutes</option>
                          <option value="h">hours</option>
                          <option value="d">days</option>
                        </Form.Select>
                      </InputGroup>
                    </div>
                    <div className="mb-2 col-12 col-md-6">
                      <Form.Label>Compare X best groups</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Compare best count"
                          aria-label="compare best count"
                          aria-describedby="basic-addon2"
                          min={1}
                          value={rule.CompareBestCount}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              CompareBestCount: e.target.valueAsNumber,
                            })
                          }
                        />
                      </InputGroup>
                      {!(rule.CompareBestCount > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                    </div>
                  </Row>
                )
              }

              {
                // integer input, min=0, required, available only if Action==compare,exists,new
                ["compare", "new", "exists", "status-breakdown"].includes(
                  rule.Action
                ) && (
                  <Row>
                    <div className="mb-3  col-12 col-md-6">
                      <Form.Label>Min number of transactions</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="min value"
                          aria-label="min value"
                          aria-describedby="basic-addon2"
                          min={0}
                          value={rule.MinValue}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              MinValue: e.target.valueAsNumber,
                            })
                          }
                        />
                      </InputGroup>
                    </div>
                    <div className="mb-3 col-12 col-md-6">
                      <Form.Label>Max number of transactions</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="max value"
                          aria-label="max value"
                          aria-describedby="basic-addon2"
                          min={0}
                          value={rule.MaxValue}
                          onChange={(e) =>
                            setRule({
                              ...rule,
                              MaxValue: e.target.valueAsNumber,
                            })
                          }
                        />
                      </InputGroup>
                    </div>
                  </Row>
                )
              }
              {rule.MinValue !== 0 && rule.MinValue >= rule.MaxValue && showErrors && (
                <div className="alert alert-danger p-1 mb-3">
                  Min number of transactions must be smaller than max number of
                  transactions.
                </div>
              )}

              {rule.Action === "status-breakdown" && (
                <Row className="mb-4">
                  <div className="mb-2 col-12 col-md-6">
                    <FormLabel>Statuses</FormLabel>
                    <Select
                      menuPlacement="auto"
                      value={statusesOptions.filter((o) =>
                        rule.Statuses.includes(o.value)
                      )}
                      onChange={(options) => {
                        if (options.length === 0) {
                          toast.error("You need at least one option selected.");
                          return;
                        }
                        setRule({
                          ...rule,
                          Statuses: options.map((o) => o.value),
                        });
                      }}
                      isMulti
                      options={statusesOptions}
                      maxMenuHeight={150}
                    />
                  </div>

                  <div className="mb-2 col-12 col-md-3">
                    <Form.Label>Are more/less than</Form.Label>
                    <Form.Select
                      aria-label="compare change direction"
                      value={rule.CompareChangeDirection}
                      onChange={(e) =>
                        setRule({
                          ...rule,
                          CompareChangeDirection: e.target.value,
                        })
                      }
                    >
                      <option value="more">More</option>
                      <option value="less">Less</option>
                    </Form.Select>
                  </div>

                  <div className="mb-2 col-12 col-md-3">
                    <Form.Label> Percentage</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Compare change"
                      aria-label="compare change"
                      aria-describedby="basic-addon2"
                      min={1}
                      value={rule.CompareChange}
                      onChange={(e) =>
                        setRule({
                          ...rule,
                          CompareChange: e.target.valueAsNumber,
                        })
                      }
                    />
                      {!(rule.CompareChange > 0) && showErrors && (
                        <div className="alert alert-danger mb-3 p-1 mt-3">
                          Minimum required value is 1.{" "}
                        </div>
                      )}
                  </div>
                
                </Row>
              )}
              <Row>
                <hr />
                <div className="mb-3">
                  <div className="mt-3 mb-1">
                    <Form.Label>Group Data</Form.Label>
                  </div>

                  <div className=" my-2">
                    <div className="mb-2 row">
                      <div className="col-3">
                        <Form.Check // prettier-ignore
                          type={"checkbox"}
                          id={`is global`}
                          label={`Make this rule global`}
                          checked={rule.IsGlobal}
                          onChange={() =>
                            setRule({ ...rule, IsGlobal: !rule.IsGlobal })
                          }
                          disabled={
                            ["new", "missing"].includes(rule.Action) &&
                            rule.IsSystem &&
                            rule.NoComms
                          }
                        />
                      </div>

                      <div className="col-9">
                        Do not group/aggregate by destination. If this is not
                        checked all data will be evaluated by destination (not
                        applicable to email)
                      </div>
                    </div>
                    <div className="mb-2 row">
                      <div className="col-3">
                        <Form.Check // prettier-ignore
                          type={"checkbox"}
                          id={`isSystem`}
                          label={`Make this rule system-wide`}
                          checked={rule.IsSystem}
                          onChange={() =>
                            setRule({ ...rule, IsSystem: !rule.IsSystem })
                          }
                          disabled={
                            rule.Action === "new" &&
                            rule.IsGlobal &&
                            rule.NoComms
                          }
                        />
                      </div>
                      <div className="col-9">
                        Do not group/aggregate by account. If this is not
                        checked all data will be evaluated by account
                      </div>
                    </div>
                    <div className="mb-2 row">
                      <div className="col-3">
                        <Form.Check // prettier-ignore
                          type={"checkbox"}
                          id={`noComms`}
                          label={`Ignore comms`}
                          checked={rule.NoComms}
                          onChange={() =>
                            setRule({ ...rule, NoComms: !rule.NoComms })
                          }
                          disabled={
                            rule.Action === "new" &&
                            rule.IsGlobal &&
                            rule.IsSystem
                          }
                        />
                      </div>
                      <div className="col-9">
                        Do not group/aggregate by comms channels. If this is not
                        checked all comms channels will be evaluated separately{" "}
                      </div>
                    </div>

                    {["new", "missing"].includes(rule.Action) &&
                      ((rule.IsGlobal && rule.IsSystem) ||
                        (rule.IsGlobal && rule.NoComms) ||
                        (rule.IsSystem && rule.NoComms)) && showErrors && (
                        <div className="alert alert-warning p-1 mb-3">
                          You can select a maximum of two options.
                        </div>
                      )}
                  </div>
                </div>
                <hr />
                <div className="mt-3 mb-1">
                  <Form.Label>Filter Comms</Form.Label>
                </div>

                <div className="mb-4 col-12 col-md-6">
                  <FormLabel>Comms</FormLabel>
                  <Select
                    value={commsOptions.filter((opt) =>
                      rule.Options.some(
                        (o) => o.Key === "data:kind" && o.Value === opt.value
                      )
                    )}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "data:kind"
                          ),
                          ...values.map((v) => ({
                            Key: "data:kind",
                            Value: v.value,
                          })),
                        ],
                      });
                    }}
                    isMulti
                    options={commsOptions}
                    maxMenuHeight={150}
                  />
                </div>

                <div className="mb-4 col-12 col-md-6">
                  <FormLabel> Ignore Comms</FormLabel>
                  <Select
                    value={commsOptions.filter((opt) =>
                      rule.Options.some(
                        (o) =>
                          o.Key === "data:kind:not" && o.Value === opt.value
                      )
                    )}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "data:kind:not"
                          ),
                          ...values.map((v) => ({
                            Key: "data:kind:not",
                            Value: v.value,
                          })),
                        ],
                      });
                    }}
                    isMulti
                    options={commsOptions}
                    maxMenuHeight={150}
                  />
                </div>

                <hr />
                <div className="mt-3 mb-1">
                  <Form.Label>Filter Countries</Form.Label>
                </div>
                <div className="mb-4 col-12 col-md-6">
                  <FormLabel>Countries</FormLabel>
                  <Select
                    menuPlacement="auto"
                    value={countriesOptions.filter((opt) =>
                      rule.Options.some(
                        (o) =>
                          o.Key === "data:country" &&
                          o.Value === opt.value.toString()
                      )
                    )}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "data:country"
                          ),
                          ...values.map((v) => ({
                            Key: "data:country",
                            Value: v.value.toString(),
                          })),
                        ],
                      });
                    }}
                    isMulti
                    options={countriesOptions}
                    maxMenuHeight={150}
                  />
                </div>
                <div className="mb-4 col-12 col-md-6">
                  <FormLabel> Ignore Countries</FormLabel>
                  <Select
                    menuPlacement="auto"
                    value={countriesOptions.filter((opt) =>
                      rule.Options.some(
                        (o) =>
                          o.Key === "data:country:not" &&
                          o.Value === opt.value.toString()
                      )
                    )}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "data:country:not"
                          ),
                          ...values.map((v) => ({
                            Key: "data:country:not",
                            Value: v.value.toString(),
                          })),
                        ],
                      });
                    }}
                    isMulti
                    options={countriesOptions}
                    maxMenuHeight={150}
                  />
                </div>

                {(["exists", "status-breakdown", "compare"].includes(
                  rule.Action
                ) ||
                  (rule.Action === "new" &&
                    (rule.MinValue !== 0 || rule.MaxValue !== 0))) && (
                  <>
                    <hr />
                    <div className="mt-3 mb-1">
                      <Form.Label>Filter Data Statuses</Form.Label>
                    </div>

                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel>Status</FormLabel>
                      <Select
                        menuPlacement="auto"
                        value={statusesOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:status" && o.Value === opt.value
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:status"
                              ),
                              ...values.map((v) => ({
                                Key: "data:status",
                                Value: v.value,
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={statusesOptions}
                        maxMenuHeight={150}
                      />
                    </div>

                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel> Ignore Status</FormLabel>
                      <Select
                        menuPlacement="auto"
                        value={statusesOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:status:not" &&
                              o.Value === opt.value
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:status:not"
                              ),
                              ...values.map((v) => ({
                                Key: "data:status:not",
                                Value: v.value,
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={statusesOptions}
                        maxMenuHeight={150}
                      />
                    </div>
                  </>
                )}

                {rule.DbRef && (
                  <>
                    <hr />
                    <div className="mt-3 mb-1">
                      <Form.Label>Filter Account</Form.Label>
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel>Account</FormLabel>
                      <Select
                        value={accountOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:account" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:account"
                              ),
                              ...values.map((v) => ({
                                Key: "data:account",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={accountOptions}
                        maxMenuHeight={150}
                      />
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel> Ignore Account</FormLabel>
                      <Select
                        value={accountOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:account:not" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:account:not"
                              ),
                              ...values.map((v) => ({
                                Key: "data:account:not",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={accountOptions}
                        maxMenuHeight={150}
                      />
                    </div>
                    <hr />
                    <div className="mt-3 mb-1">
                      <Form.Label>Filter Customers</Form.Label>
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <div>Customers</div>
                      <Select
                        value={customerOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:customer" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:customer"
                              ),
                              ...values.map((v) => ({
                                Key: "data:customer",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={customerOptions}
                        maxMenuHeight={150}
                      />
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <div> Ignore Customers</div>
                      <Select
                        value={customerOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:customer:not" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:customer:not"
                              ),
                              ...values.map((v) => ({
                                Key: "data:customer:not",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        options={customerOptions}
                        maxMenuHeight={150}
                      />
                    </div>
                    <hr />
                    <div className="mt-3 mb-1">
                      <Form.Label>Filter Customers parent</Form.Label>
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel>Customers parent: </FormLabel>
                      <Select
                        value={customerOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:parent" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:parent"
                              ),
                              ...values.map((v) => ({
                                Key: "data:parent",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        maxMenuHeight={150}
                        options={customerOptions.filter(
                          (o) => o.customer.IsParent
                        )}
                      />
                    </div>
                    <div className="mb-4 col-12 col-md-6">
                      <FormLabel> Ignore Customers parent: </FormLabel>
                      <Select
                        value={customerOptions.filter((opt) =>
                          rule.Options.some(
                            (o) =>
                              o.Key === "data:parent:not" &&
                              o.Value === opt.value.toString()
                          )
                        )}
                        onChange={(values) => {
                          setRule({
                            ...rule,
                            Options: [
                              ...rule.Options.filter(
                                (opt) => opt.Key !== "data:parent:not"
                              ),
                              ...values.map((v) => ({
                                Key: "data:parent:not",
                                Value: v.value.toString(),
                              })),
                            ],
                          });
                        }}
                        isMulti
                        maxMenuHeight={150}
                        options={customerOptions.filter(
                          (o) => o.customer.IsParent
                        )}
                      />
                    </div>
                    <hr />
                  </>
                )}
              </Row>
            </Tab>
            <Tab eventKey="2" title="Weekdays and time">
              <div className="row g-4 my-3">
                <div className="col-12 col-md-4">
                  <Form.Label>Run After</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      min={0}
                      max={24}
                      value={rule.RunAfter.toString()
                        .slice(0, 2)
                        .padStart(2, "0")}
                      onChange={(e) => {
                        setRule({
                          ...rule,
                          RunAfter:
                            e.target.value.padStart(2, "0") +
                            ":" +
                            rule.RunAfter.toString().slice(3),
                        });
                      }}
                    />
                    <InputGroupText>:</InputGroupText>
                    <Form.Control
                      type="number"
                      min={0}
                      max={59}
                      value={rule.RunAfter.toString().slice(3).padStart(2, "0")}
                      onChange={(e) => {
                        setRule({
                          ...rule,
                          RunAfter:
                            rule.RunAfter.toString().slice(0, 2) +
                            ":" +
                            e.target.value.padStart(2, "0"),
                        });
                      }}
                    />
                  </InputGroup>
                </div>

                <div className="col-12 col-md-4">
                  <Form.Label>Run Before</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      min={0}
                      max={24}
                      value={rule.RunBefore.slice(0, 2).padStart(2, "0")}
                      onChange={(e) => {
                        setRule({
                          ...rule,
                          RunBefore:
                            e.target.value.padStart(2, "0") +
                            ":" +
                            rule.RunBefore.toString().slice(3),
                        });
                      }}
                    />
                    <InputGroupText>:</InputGroupText>
                    <Form.Control
                      type="number"
                      min={0}
                      max={59}
                      value={rule.RunBefore.slice(3).padStart(2, "0")}
                      onChange={(e) => {
                        setRule({
                          ...rule,
                          RunBefore:
                            rule.RunBefore.toString().slice(0, 2) +
                            ":" +
                            e.target.value.padStart(2, "0"),
                        });
                      }}
                    />
                  </InputGroup>
                </div>
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnMonday`}
                  label={`Run On Monday`}
                  checked={rule.RunOnMonday}
                  onChange={() =>
                    setRule({ ...rule, RunOnMonday: !rule.RunOnMonday })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnTuesday`}
                  label={`Run On Tuesday`}
                  checked={rule.RunOnTuesday}
                  onChange={() =>
                    setRule({ ...rule, RunOnTuesday: !rule.RunOnTuesday })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnWednesday`}
                  label={`Run On Wednesday`}
                  checked={rule.RunOnWednesday}
                  onChange={() =>
                    setRule({ ...rule, RunOnWednesday: !rule.RunOnWednesday })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnThursday`}
                  label={`Run On Thursday`}
                  checked={rule.RunOnThursday}
                  onChange={() =>
                    setRule({ ...rule, RunOnThursday: !rule.RunOnThursday })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnFriday`}
                  label={`Run On Friday`}
                  checked={rule.RunOnFriday}
                  onChange={() =>
                    setRule({ ...rule, RunOnFriday: !rule.RunOnFriday })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnSaturday`}
                  label={`Run On Saturday`}
                  checked={rule.RunOnSaturday}
                  onChange={() =>
                    setRule({
                      ...rule,
                      RunOnSaturday: !rule.RunOnSaturday,
                    })
                  }
                />
              </div>
              <div className="mb-2">
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`RunOnSunday`}
                  label={`Run On Sunday`}
                  checked={rule.RunOnSunday}
                  onChange={() =>
                    setRule({ ...rule, RunOnSunday: !rule.RunOnSunday })
                  }
                />
              </div>
            </Tab>
            <Tab eventKey="3" title="Recipients">
              <Form.Group className="row" controlId="email">
                <div className="col-2 mt-2">
                  <Form.Label>Email</Form.Label>
                </div>
                <div className="mb-2 col-10 ">
                  <CreatableSelect
                    value={rule.Options.filter(
                      (o) => o.Key === "alert:email"
                    ).map((o) => ({ value: o.Value, label: o.Value }))}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "alert:email"
                          ),
                          ...values.map((v) => ({
                            Key: "alert:email",
                            Value: v.value.toString(),
                          })),
                        ],
                      });
                    }}
                    isValidNewOption={(v) => {
                      const isValid = validateEmail(v);
                      setEmailError(v && !isValid);
                      return isValid;
                    }}
                    isMulti
                    isClearable
                    components={{
                      DropdownIndicator: null,
                      ...(emailError
                        ? {
                            Menu: ({ children, ...rest }) => (
                              <components.Menu {...rest}>
                                <div className="alert alert-warning m-0">
                                  Please enter a valid email
                                </div>
                              </components.Menu>
                            ),
                          }
                        : {}),
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group className="row" controlId="sms">
                <div className="col-2 mt-2">
                  <Form.Label>SMS</Form.Label>
                </div>
                <div className="mb-2 col-10 ">
                  <CreatableSelect
                    value={rule.Options.filter(
                      (o) => o.Key === "alert:sms"
                    ).map((o) => ({ value: o.Value, label: o.Value }))}
                    onChange={(values) => {
                      setRule({
                        ...rule,
                        Options: [
                          ...rule.Options.filter(
                            (opt) => opt.Key !== "alert:sms"
                          ),
                          ...values.map((v) => ({
                            Key: "alert:sms",
                            Value: v.value.toString(),
                          })),
                        ],
                      });
                    }}
                    isValidNewOption={(v) => {
                      const isValid = isValidPhoneNumber(v);
                      setSmsError(v && !isValid);
                      return isValid;
                    }}
                    isMulti
                    isClearable
                    components={{
                      DropdownIndicator: null,
                      ...(smsError
                        ? {
                            Menu: ({ children, ...rest }) => (
                              <components.Menu {...rest}>
                                <div className="alert alert-warning m-0">
                                  Please enter a valid phone number in
                                  international format starting with (+..)
                                </div>
                              </components.Menu>
                            ),
                          }
                        : {}),
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group className="row" controlId="sms">
                <div className="mb-2 offset-2 mt-2">
                  <Form.Check // prettier-ignore
                    type={"checkbox"}
                    id={`SendToSlack`}
                    label={`Send to Slack`}
                    checked={rule.SendToSlack}
                    onChange={() =>
                      setRule({ ...rule, SendToSlack: !rule.SendToSlack })
                    }
                  />
                </div>
              </Form.Group>
            </Tab>
          </Tabs>
          <Button variant="secondary" type="submit" className="mt-4 btn-sm">
            Submit
          </Button>
        </Form>
      </Container>
    )
  );
}
